import { FlightDetails } from "../components/interfaces/template.interface";

export const flights =
    [
        {
            "_id": "6758667a7fea2f686ec23e09",
            "flightNumber": "OD 0571",
            "scheduledTravelTime": "2024-12-12T02:35:00.000Z",
            "actionCode": "FC",
            "afskey": 13449848,
            "aircraftType": "738",
            "codeShareFlight": [],
            "counterClosingTime": "2024-12-12T01:35:00.000Z",
            "counterOpeningTime": "2024-12-11T23:35:00.000Z",
            "finalLoungeTime": "2024-12-12T04:00:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T03:40:00.000Z",
            "loungeClosingTime": "2024-12-12T04:10:00.000Z",
            "loungeOpeningTime": "2024-12-12T03:20:00.000Z",
            "officialFlightDate": "2024-12-12T02:35:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "HAN",
                    "stationNumber": 2
                },
                {
                    "airport": "DXB",
                    "stationNumber": 3
                }
            ],
            "terminalId": "MTB",
            "checkInType": {
                "name": "C",
                "description": "Common"
            },
            "aircraftRegnNo": "9MLDG",
            "standCode": "C034",
            "loungeCode": "C034",
            "ETA": "2024-12-12T04:20:00.000Z",
            "remarkCode": {
                "key": "GFC",
                "description": "FINAL CALL"
            },
            "actualArrivalDepartureTime": "2024-12-12T04:20:00.000Z",
            "checkInDesks": "Z03-Z06",
            "checkInRow": "Z",
        },
        {
            "_id": "6758667f7fea2f686ec25d6d",
            "flightNumber": "MH 0485",
            "scheduledTravelTime": "2024-12-12T03:05:00.000Z",
            "actionCode": "ATD",
            "afskey": 13450163,
            "aircraftType": "73H",
            "codeShareFlight": [],
            "counterClosingTime": "2024-12-12T02:05:00.000Z",
            "counterOpeningTime": "2024-12-12T00:05:00.000Z",
            "finalLoungeTime": "2024-12-12T02:45:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T02:25:00.000Z",
            "loungeClosingTime": "2024-12-12T02:55:00.000Z",
            "loungeOpeningTime": "2024-12-12T02:05:00.000Z",
            "officialFlightDate": "2024-12-12T03:05:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "MLE",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "aircraftRegnNo": "9MMXO",
            "checkInType": {
                "name": "C",
                "description": "Common"
            },
            "loungeCode": "G010R",
            "standCode": "A010R",
            "ETA": "2024-12-12T03:52:00.000Z",
            "actualArrivalDepartureTime": "2024-12-12T03:52:00.000Z",
            "remarkCode": {
                "key": "GOP",
                "description": "GATE OPEN"
            },
            "checkInDesks": "M03-M06",
            "checkInRow": "M",
        },
        {
            "_id": "6758667f7fea2f686ec25e54",
            "scheduledTravelTime": "2024-12-12T03:05:00.000Z",
            "flightNumber": "SQ 0107",
            "actionCode": "ETD",
            "afskey": 13449756,
            "aircraftType": "73H",
            "codeShareFlight": [
                "AI 8189",
                "MH 5725",
                "NZ 3407",
                "VA 5427"
            ],
            "counterClosingTime": "2024-12-12T02:20:00.000Z",
            "counterOpeningTime": "2024-12-12T00:05:00.000Z",
            "finalLoungeTime": "2024-12-12T02:45:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T02:25:00.000Z",
            "loungeClosingTime": "2024-12-12T02:55:00.000Z",
            "loungeOpeningTime": "2024-12-12T02:05:00.000Z",
            "officialFlightDate": "2024-12-12T03:05:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "SIN",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "checkInType": {
                "name": "D",
                "description": "Desk"
            },
            "standCode": "C015",
            "loungeCode": "C015",
            "ETA": "2024-12-12T04:15:00.000Z",
            "actualArrivalDepartureTime": "2024-12-12T04:15:00.000Z",
            "remarkCode": {
                "key": "FDL",
                "description": "DELAYED"
            },
            "aircraftRegnNo": "9VMGK"
        },
        {
            "_id": "6758666f7fea2f686ec20335",
            "scheduledTravelTime": "2024-12-12T03:15:00.000Z",
            "flightNumber": "MH 2646",
            "actionCode": "ATD",
            "afskey": 13450391,
            "aircraftType": "73H",
            "codeShareFlight": [
                "6E 3772",
                "FY 7660",
                "WY 5715",
                "TK 8171",
                "QR 5458"
            ],
            "counterClosingTime": "2024-12-12T02:15:00.000Z",
            "counterOpeningTime": "2024-12-12T00:15:00.000Z",
            "finalLoungeTime": "2024-12-12T03:00:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T02:45:00.000Z",
            "loungeClosingTime": "2024-12-12T03:05:00.000Z",
            "loungeOpeningTime": "2024-12-12T02:15:00.000Z",
            "officialFlightDate": "2024-12-12T03:15:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "BKI",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "aircraftRegnNo": "9MMXU",
            "checkInType": {
                "name": "C",
                "description": "Common"
            },
            "loungeCode": "B007",
            "standCode": "B007",
            "ETA": "2024-12-12T04:03:00.000Z",
            "actualArrivalDepartureTime": "2024-12-12T04:03:00.000Z",
            "remarkCode": {
                "key": "FCL",
                "description": "CANCELLED"
            }
        },
        {
            "_id": "6756608a7fea2f686e7e883d",
            "scheduledTravelTime": "2024-12-12T03:35:00.000Z",
            "flightNumber": "BT 9802",
            "actionCode": "ATD",
            "afskey": 13447151,
            "aircraftRegnNo": "YLABD",
            "aircraftType": "223",
            "codeShareFlight": [],
            "counterClosingTime": "2024-12-12T03:05:00.000Z",
            "counterOpeningTime": "2024-12-12T00:35:00.000Z",
            "finalLoungeTime": "2024-12-12T03:15:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T02:55:00.000Z",
            "loungeClosingTime": "2024-12-12T03:25:00.000Z",
            "loungeOpeningTime": "2024-12-12T02:35:00.000Z",
            "officialFlightDate": "2024-12-12T03:35:00.000Z",
            "serviceTypeCode": "P",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "HND",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "loungeCode": "L004",
            "standCode": "K004",
            "ETA": "2024-12-12T04:02:00.000Z",
            "actualArrivalDepartureTime": "2024-12-12T04:02:00.000Z",
            "remarkCode": {
                "key": "GBD",
                "description": "BOARDING"
            }
        },
        {
            "_id": "6759a2597fea2f686eea4404",
            "flightNumber": "IU 0191",
            "scheduledTravelTime": "2024-12-12T03:40:00.000Z",
            "actionCode": "ATD",
            "afskey": 13452338,
            "aircraftRegnNo": "PKSAJ",
            "aircraftType": "320",
            "codeShareFlight": [],
            "counterClosingTime": "2024-12-12T02:40:00.000Z",
            "counterOpeningTime": "2024-12-12T00:40:00.000Z",
            "finalLoungeTime": "2024-12-12T03:20:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T03:00:00.000Z",
            "loungeClosingTime": "2024-12-12T03:30:00.000Z",
            "loungeOpeningTime": "2024-12-12T02:40:00.000Z",
            "officialFlightDate": "2024-12-12T03:40:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "PKU",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "checkInType": {
                "name": "D",
                "description": "Desk"
            },
            "loungeCode": "C036",
            "standCode": "C036",
            "ETA": "2024-12-12T04:05:00.000Z",
            "actualArrivalDepartureTime": "2024-12-12T04:05:00.000Z",
            "remarkCode": {
                "key": "FDP",
                "description": "DEPARTED"
            }
        },
        {
            "_id": "6758667b7fea2f686ec247ec",
            "scheduledTravelTime": "2024-12-12T04:00:00.000Z",
            "flightNumber": "MH 0792",
            "actionCode": "ETD",
            "afskey": 13450022,
            "aircraftType": "73H",
            "codeShareFlight": [],
            "counterClosingTime": "2024-12-12T03:00:00.000Z",
            "counterOpeningTime": "2024-12-12T01:00:00.000Z",
            "finalLoungeTime": "2024-12-12T03:40:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T03:20:00.000Z",
            "loungeClosingTime": "2024-12-12T03:50:00.000Z",
            "loungeOpeningTime": "2024-12-12T03:00:00.000Z",
            "officialFlightDate": "2024-12-12T04:00:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "CNX",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "aircraftRegnNo": "9MMXX",
            "checkInType": {
                "name": "C",
                "description": "Common"
            },
            "standCode": "A006R",
            "loungeCode": "G006R",
            "ETA": "2024-12-12T04:37:00.000Z",
            "actualArrivalDepartureTime": "2024-12-12T04:37:00.000Z",
            "remarkCode": {
                "key": "FRT",
                "description": "RETIME"
            }
        },
        {
            "_id": "6758667b7fea2f686ec248d3",
            "scheduledTravelTime": "2024-12-12T04:05:00.000Z",
            "flightNumber": "8M 0502",
            "actionCode": "C",
            "afskey": 13449604,
            "aircraftType": "322",
            "codeShareFlight": [
                "MH 4650"
            ],
            "counterClosingTime": "2024-12-12T03:05:00.000Z",
            "counterOpeningTime": "2024-12-12T01:05:00.000Z",
            "finalLoungeTime": "2024-12-12T03:45:00.000Z",
            "isDisplay": true,
            "loungeBoardingTime": "2024-12-12T03:25:00.000Z",
            "loungeClosingTime": "2024-12-12T03:55:00.000Z",
            "loungeOpeningTime": "2024-12-12T03:05:00.000Z",
            "officialFlightDate": "2024-12-12T04:05:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUL",
                    "stationNumber": 1
                },
                {
                    "airport": "RGN",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "checkInType": {
                "name": "D",
                "description": "Desk"
            },
            "loungeCode": "C023",
            "standCode": "C023",
            "aircraftRegnNo": "XYALJ",
            "ETA": "2024-12-12T04:05:00.000Z",
            "actualArrivalDepartureTime": "2024-12-12T04:05:00.000Z",
            "remarkCode": {
                "key": "GCL",
                "description": "GATE CLOSED"
            }
        },
    ];

export const arrivalFlights =
    [
        {
            "_id": "6766e6de7fea2f686ea796b9",
            "flightNumber": "MH 0159",
            "scheduledTravelTime": "2024-12-23T03:15:00.000Z",
            "codeShareFlight": [],
            "isDisplay": true,
            "stations": [
                {
                    "airport": "MED",
                    "stationNumber": 1
                },
                {
                    "airport": "KUL",
                    "stationNumber": 2
                }
            ],
            "actionCode": "ETA",
            "afskey": 13478748,
            "aircraftType": "332",
            "officialFlightDate": "2024-12-22T18:30:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "terminalId": "MTB",
            "aircraftRegnNo": "9MMTW",
            "linkedToFlightNo": "MH 0150",
            "ETA": "2024-12-23T05:15:00.000Z",
            "remarkCode": {
                "key": "FDL",
                "description": "DELAYED"
            },
            "standCode": "C037",
            "loungeCode": "C037"
        },
        {
            "_id": "6766e6d37fea2f686ea7513d8",
            "flightNumber": "MH 1335D",//"MH 1269",
            "scheduledTravelTime": "2024-12-23T03:40:00.000Z",
            "actionCode": "L",
            "afskey": 13479450,
            "aircraftType": "73H",
            "codeShareFlight": [
                "FY 4233",
                "PR 3618",
                "TK 4882",
                "SQ 5525",
                "QR 5036"
            ],
            "isDisplay": true,
            "officialFlightDate": "2024-12-23T02:40:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUA",
                    "stationNumber": 1
                },
                {
                    "airport": "KUL",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "linkedToFlightNo": "MH 7492",
            "aircraftRegnNo": "9MMSE",
            "loungeCode": "B011",
            "standCode": "B011",
            "ETA": "2024-12-23T04:39:00.000Z",
            "actualArrivalDepartureTime": "2024-12-23T04:39:00.000Z",
            "remarkCode": {
                "key": "CFB",
                "description": "FIRST BAG"
            },
            "lastBagReceivedAt": "2024-12-23T05:04:43.541Z"
        },
        {
            "_id": "6766e6d37fea2f686ea7513d",
            "flightNumber": "MH 1335D",//"MH 1269",
            "scheduledTravelTime": "2024-12-23T03:40:00.000Z",
            "actionCode": "L",
            "afskey": 13479450,
            "aircraftType": "73H",
            "codeShareFlight": [
                "FY 4233",
                "PR 3618",
                "TK 4882",
                "SQ 5525",
                "QR 5036"
            ],
            "isDisplay": true,
            "officialFlightDate": "2024-12-23T02:40:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "KUA",
                    "stationNumber": 1
                },
                {
                    "airport": "KUL",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "linkedToFlightNo": "MH 7492",
            "aircraftRegnNo": "9MMSE",
            "loungeCode": "B011",
            "standCode": "B011",
            "ETA": "2024-12-23T04:39:00.000Z",
            "actualArrivalDepartureTime": "2024-12-23T04:39:00.000Z",
            "remarkCode": {
                "key": "CLB",
                "description": "LAST BAG"
            },
            "lastBagReceivedAt": "2024-12-23T05:04:43.541Z"
        },
        {
            "_id": "6766e6d67fea2f686ea75eb4",
            "flightNumber": "AK 0891",
            "scheduledTravelTime": "2024-12-23T03:45:00.000Z",
            "actionCode": "O",
            "afskey": 13478967,
            "aircraftType": "320",
            "codeShareFlight": [],
            "isDisplay": true,
            "officialFlightDate": "2024-12-23T01:35:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "DMK",
                    "stationNumber": 1
                },
                {
                    "airport": "KUL",
                    "stationNumber": 2
                }
            ],
            "terminalId": "KL2",
            "linkedToFlightNo": "AK 5748",
            "aircraftRegnNo": "9MRAV",
            "standCode": "K018",
            "loungeCode": "L018",
            "ETA": "2024-12-23T05:03:00.000Z",
            "remarkCode": {
                "key": "COP",
                "description": "CAROUSEL OPEN"
            },
            "actualArrivalDepartureTime": "2024-12-23T05:03:00.000Z"
        },
        {
            "_id": "6767f9367fea2f686ecb3dd2",
            "scheduledTravelTime": "2024-12-23T04:00:00.000Z",
            "flightNumber": "MH 1335D",
            "actionCode": "O",
            "afskey": 13479699,
            "aircraftRegnNo": "9MMLO",
            "aircraftType": "73H",
            "codeShareFlight": [],
            "isDisplay": true,
            "officialFlightDate": "2024-12-23T03:00:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "stations": [
                {
                    "airport": "TGG",
                    "stationNumber": 1
                },
                {
                    "airport": "KUL",
                    "stationNumber": 2
                }
            ],
            "terminalId": "MTB",
            "linkedToFlightNo": "MH 1208",
            "loungeCode": "B007",
            "standCode": "B007",
            "ETA": "2024-12-23T04:33:00.000Z",
            "remarkCode": {
                "key": "CCL",
                "description": "CAROUSEL CLOSED"
            },
            "actualArrivalDepartureTime": "2024-12-23T04:33:00.000Z"
        },
        {
            "_id": "6766e6e07fea2f686ea7a788",
            "flightNumber": "OD 0525",
            "scheduledTravelTime": "2024-12-23T04:15:00.000Z",
            "codeShareFlight": [],
            "isDisplay": true,
            "stations": [
                {
                    "airport": "DMK",
                    "stationNumber": 1
                },
                {
                    "airport": "KUL",
                    "stationNumber": 2
                }
            ],
            "actionCode": "L",
            "afskey": 13478591,
            "aircraftType": "73H",
            "officialFlightDate": "2024-12-23T02:15:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "terminalId": "MTB",
            "aircraftRegnNo": "9MLDC",
            "linkedToFlightNo": "OD 0586",
            "loungeCode": "C033",
            "standCode": "C033",
            "ETA": "2024-12-23T04:37:00.000Z",
            "actualArrivalDepartureTime": "2024-12-23T04:37:00.000Z",
            "remarkCode": {
                "key": "FCL",
                "description": "CANCELLED"
            },
            "lastBagReceivedAt": "2024-12-23T05:06:02.506Z"
        },
        {
            "_id": "6766e6e17fea2f686ea7abcb",
            "flightNumber": "MH 2543",
            "scheduledTravelTime": "2024-12-23T04:15:00.000Z",
            "codeShareFlight": [
                "FY 7535",
                "GA 8935",
                "PR 3569",
                "CI 9429",
                "SQ 5657",
                "6E 3739",
                "QR 5423"
            ],
            "isDisplay": true,
            "stations": [
                {
                    "airport": "KCH",
                    "stationNumber": 1
                },
                {
                    "airport": "KUL",
                    "stationNumber": 2
                }
            ],
            "actionCode": "L",
            "afskey": 13479514,
            "aircraftType": "73H",
            "officialFlightDate": "2024-12-23T02:25:00.000Z",
            "serviceTypeCode": "J",
            "specialFlightIndicator": "N",
            "terminalId": "MTB",
            "aircraftRegnNo": "9MMXC",
            "linkedToFlightNo": "MH 0721",
            "loungeCode": "B002R",
            "standCode": "B002R",
            "ETA": "2024-12-23T04:28:00.000Z",
            "actualArrivalDepartureTime": "2024-12-23T04:28:00.000Z",
            "remarkCode": {
                "key": "FLD",
                "description": "LANDED"
            },
            "lastBagReceivedAt": "2024-12-23T05:08:35.911Z"
        },
    ];